import React from "react";
import { Routes, Route } from "react-router-dom";
import PolicyList from "./PolicyList";
import PolicyCreate from "./PolicyCreate";
import PolicyDetail from "./PolicyDetail";
import "../../../assets/css/policyPrint.css";
import ProtectedRoutes from "components/common/routing/ProtectedRoutes";

export default function PoliciesIndex() {
  return (
    <Routes>
      <Route index element={
        <ProtectedRoutes permissionKey="Policies-view">
                  <PolicyList />
                </ProtectedRoutes>
        } />
      <Route path="create" element={
        <ProtectedRoutes permissionKey="Policies-manage">
                  <PolicyCreate />
                </ProtectedRoutes>
        }/>
      <Route path="detail" element= {
        <ProtectedRoutes permissionKey="Policies-manage">
                  <PolicyDetail />
                </ProtectedRoutes>
        }/>
    </Routes>
  );
}
